import AnimationController from "./animation"

export default class extends AnimationController {
    // Continue is hidden until this screen's fade-in sequence finishes (it is
    // in onboarding_controller's animationControlledSteps), so the stagger is
    // how long every web onboarder waits on a screen that asks nothing. At the
    // inherited 1500ms the gate released at ~5.1s: 71% of continues landed in
    // the 5-8s band, only 3.8% came in under 5s, and the step abandoned at
    // 3.0% against 0.13% on the static education screen right after it. 700ms
    // matches the skin_profile_generation override and releases at ~2.7s.
    static values = {
        delay: { type: Number, default: 700 }
    }
}
